/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { usePermissions, TextField, FunctionField, SimpleList, Datagrid, List } from 'react-admin';
import {
    useMediaQuery, makeStyles, CircularProgress, Dialog, DialogContent, DialogActions, TextField as MuiTextField, Button, FormControl, InputLabel, Select, MenuItem, Avatar
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import AddIcon from '@material-ui/icons/Add';
import config from "./config.json";
import { useLocation } from 'react-router-dom';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import { stringify } from 'query-string';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomSearch from './components/CustomSearch';
import { vehicleSvgs } from "./sharedData";
import CustomPagination from './components/CustomPagination';
import CustomFilter from './components/CustomFilter';
import ScrollableTable from './components/ScrollableTable';
import moment from 'moment';
import { Link } from "react-router-dom";
import queryString from 'query-string';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const renderVehicleType = row => (
    row.vehicle_type ?
        <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
            <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 4 }} alt={row.vehicle_type_label} />
        </div>
        :
        null
);

export const QRCodesList = props => {
    const classes = useStyles();
    const location = useLocation()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const { permissions } = usePermissions();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["uuid"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "uuid");
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    let filterTypesInitState = [
        {
            filterType: "Status",
            dataList: [{ name: "ACTIVE", id: 2 }, { name: "IN-ACTIVE", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Pass Type",
            dataList: [{ name: "Monthly", id: 2 }, { name: "Valet", id: 4 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]
    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const timeFormatMobile = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
    };

    const timeFormat = (time) => {
        let addSeconds = showTimeTillSeconds ? ":ss" : "";
        let format = use24HourFormat ? `HH:mm${addSeconds}` : `hh:mm${addSeconds} A`
        return <div>
            <div className='logsTableDataColor1 fontWeightBold'>{moment(time).format(format)}</div>
            <div className='logsTableDataColor2 fontWeightMedium'>{moment(time).format("DD/MM/YYYY")}</div>
        </div>
    }

    useEffect(() => {
        let values = {}
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Status") values = { ...values, status: filterListValue[val].value ? filterListValue[val].value === "ACTIVE" ? "1" : "0" : undefined }
                if (filterListValue[val].filterType === "Pass Type") values = { ...values, type: filterListValue[val].value ? filterListValue[val].value === "Monthly" ? "monthly_pass" : "valet" : undefined }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) setSettingFilterFormat({})
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter &&
                <ParkingSearchSelector
                    value={currentParking}
                    onChange={onParkingChange}
                    clearable={true}
                    pathName={location.pathname}
                />
            }

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            <GenerateQRCodes />
        </div>

        <List
            {...props}
            style={{ marginTop: 10 }}
            title="QR Codes"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            actions={false}
            pagination={<CustomPagination />}
        >
            {isSmallDevice ?
                <SimpleList
                    // leftIcon={row => row.vehicle_type ? <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ width: 28, height: 28, marginTop: 8, marginRight: 10, overflow: "visible" }} /> : undefined}
                    primaryText={record => record["uuid"]}
                    secondaryText={record => (<div>
                        <div style={{ color: customTheme.palette.secondary.main }}>{record["parking_name"] ? `Parking Name: ${record["parking_name"]}` : ""}</div>
                        {record.type && <div><span style={{ color: "#5a5a5a", textTransform: "capitalize" }}>Pass: </span>{record.type.replace(/[\s_]/g, ' ')}</div>}
                        {record.vehicle_number && record.type !== "valet" && <div>
                            <Link to={`/monthlyPass?${queryString.stringify({ vehicle_number: record.vehicle_number })}`}>
                                <span style={{ color: "#5a5a5a" }}>Vehicle No: </span>{record.vehicle_number}
                            </Link>
                        </div>}
                        {record.vehicle_number && record.type === "valet" && <div> <span style={{ color: "#5a5a5a" }}>Vehicle No: </span>{record.vehicle_number} </div>}
                        {record.created_at && <div><span style={{ color: "#5a5a5a" }}>Created At: </span>{timeFormatMobile(record["created_at"])}</div>}
                        {record.updated_at && <div><span style={{ color: "#5a5a5a" }}>Updated At: </span>{timeFormatMobile(record["updated_at"])}</div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid className='customStyleDataGrid' component={ScrollableTable}>
                    <TextField source="uuid" label="Id" />
                    <FunctionField source="vehicle_number" label="Vehicle No." render={record => record && record["vehicle_number"] !== null ?
                        record.type !== "valet" ?
                            <Link to={record.type === "valet" ? `/valet?${queryString.stringify({ vehicle_number: record.vehicle_number })}` : `/monthlyPass?${queryString.stringify({ vehicle_number: record.vehicle_number })}`} style={{ textDecoration: "none" }}>
                                <span className='fontWeightSemiBold secondaryColor'>{record["vehicle_number"]}</span>
                            </Link>
                            : <span className='fontWeightSemiBold secondaryColor'>{record["vehicle_number"]}</span>
                        : "-"
                    } />
                    <FunctionField source="type" label="Pass" style={{ textTransform: "capitalize" }} render={record => record && record.type !== '' ? record.type.replace(/[\s_]/g, ' ') : "-"} />
                    {/* <FunctionField source="vehicle_type" label="Type" render={record => record && renderVehicleType(record)} sortable/> */}
                    <FunctionField source="status" label="Status" render={record => <span style={{ color: record.status ? "#18CC69" : "#F7685B", backgroundColor: record.status ? "#18CC6919" : "#F7685B19", borderRadius: "2px", padding: "1px 4px" }}>{record && record.status ? "Active" : 'In-Active'}</span>} />
                    <FunctionField source="last_start_date" label="Renewed At" render={record => record && record.last_start_date !== '' ? timeFormat(record.last_start_date) : "-"} />
                    <FunctionField source="created_at" label="Created At" render={record => record && record.created_at !== '' ? timeFormat(record.created_at) : "-"} />
                    <FunctionField source="updated_at" label="Updated At" render={record => record && record.updated_at !== '' ? timeFormat(record.updated_at) : "-"} />
                </Datagrid>
            }
        </List>
    </div>
};

function GenerateQRCodes() {
    const [dialogVisible, setDialogVisible] = useState(false);
    const [loading, setLoading] = useState(false)
    const [accessKeyId, setAccessKeyId] = useState("")
    const [parkingName, setParkingName] = useState("")
    const [options, setOptions] = useState([]);
    const [autovalue, setAutoValue] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [quantity, setQuantity] = useState("");
    const [passType, setPassType] = useState("monthly_pass")

    const openDialog = () => setDialogVisible(true);

    const closeDialog = () => {
        setDialogVisible(false)
        resetStates()
    };

    const passTypeHandler = (event) => setPassType(event.target.value);

    const generateQrHandler = () => {
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            count: parseInt(quantity),
            access_key: accessKeyId,
            type: passType
        };
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/qrCodeGenerate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(params)
        })
            .then(response => {
                if (!response.ok) {
                    return notify('Something went wrong', 'warning');
                }
                return response.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `QR_Codes ${parkingName} ${quantity} ${moment().format("YYYY-MM-DD HH:mm:ss")}.zip`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                closeDialog()
            })
            .catch(error => {
                console.log(error)
                notify('Something went wrong', 'warning');
            })
            .finally(() => setLoading(false))
    };

    const fetchParkings = () => {
        const token = sessionStorage.getItem('token');
        if (token != null && token !== "") {
            //setLoading(true);
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify({ name: inputValue ? inputValue : undefined }),
                sort: JSON.stringify(["id", "ASC"]),
                page: 1,
                perPage: 10
            }
            fetch(`${config.HOST_NAME}/crm/v3/uniqueParkingAccessKeys?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    if (responseJson.success) {
                        let data = responseJson.data
                        let results = []
                        for (let val in data) results.push({ access_key_id: data[val].id, access_key: data[val].access_key, name: data[val].name })
                        setOptions([...results])

                    } else notify(responseJson.message, 'warning');
                })
                .catch((e) => {
                    notify('Error fetching data', 'warning');
                    console.log(e);
                });
        }
    };

    const resetStates = () => {
        setAccessKeyId("")
        setOptions([])
        setAutoValue("")
        setInputValue("")
        setQuantity("")
    }

    useEffect(() => {
        fetchParkings()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue])

    return <div>

        <Button className='buttonStyle addBorderRadius' title='Generate QR' variant='contained' color="secondary" disableElevation size="small" onClick={openDialog}>
            <AddIcon style={{ fontSize: "20px" }} />
        </Button>

        <Dialog fullWidth open={dialogVisible} onClose={closeDialog}>
            <DialogContent>
                <Autocomplete id="controllable-states-demo" size="small" options={options} getOptionLabel={option => option.name} style={{ marginBottom: 20 }} value={autovalue}
                    onChange={(event, newValue) => {
                        if (newValue) {
                            setAutoValue(newValue);
                            setAccessKeyId(newValue.access_key)
                            setParkingName(newValue.name)
                        }
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                    renderInput={(params) => <MuiTextField {...params} label="Parking Name" variant="outlined" />}
                />

                <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", flexWrap: "wrap", gap: 20 }}>
                    <MuiTextField style={{ width: 150 }} label="Quantity" size="small" variant='outlined' value={quantity} onChange={(e) => setQuantity(e.target.value)}>
                    </MuiTextField>
                    <MuiTextField style={{ width: 150 }} size="small" variant='outlined' label="Pass Type" select value={passType} onChange={passTypeHandler}>
                        <MenuItem value="monthly_pass">Monthly</MenuItem>
                        <MenuItem value="valet">Valet</MenuItem>
                    </MuiTextField>
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                    Close
                </Button>
                <Button onClick={generateQrHandler} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18cc69", color: "#FFF" }} disableElevation>
                    Generate {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                </Button>
            </DialogActions>
        </Dialog>
    </div>
}